<template>
  <div :class="[_class, getService().code]">
    <div
      id="maincontent"
      role="main"
      tabindex="-1"
      :aria-label="resolveTxt('skin.main.content', 'Main Content')"
      :class="additionalClasses"
    >
      <div class="grid-container">
        <div class="grid-x grid-margin-x">
          <div class="small-12 cell">
            <slot name="main_content"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);
    const displayParams = inject("displayParams", false);

    return {
      resolveTxt,
      displayParams
    };
  },
  name: "CatPrintLayout",
  props: {
    viewtree: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      additionalClasses: []
    };
  },
  methods: {
    toggleMenu: function (evt) {
      this.drawer = !this.drawer;
    },
    addContentClass: function (classname) {
      if (this.additionalClasses.indexOf(classname) == -1) {
        this.additionalClasses.push(classname);
      }
    }
  },

  computed: {
    _class: function () {
      return {
        "print-preview": true
      };
    }
  },
  provide: function () {
    return {
      addContentClass: this.addContentClass,
      headingLevel: this.hLevel,
      showLabelOptional: this.getService().showLabelOptional,
      showLabelRequired: this.getService().showLabelRequired,
      suppressOffscreenOptional: this.getService().suppressOffscreenOptional,
      suppressOffscreenRequired: this.getService().suppressOffscreenRequired
    };
  }
});
</script>
